import { render, staticRenderFns } from "./PageBuyerVerifications.vue?vue&type=template&id=34f37d5c&"
import script from "./PageBuyerVerifications.vue?vue&type=script&lang=js&"
export * from "./PageBuyerVerifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports